import { render } from "./MainLayout.vue?vue&type=template&id=dbd54cb6"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=dbd54cb6&lang=css"

import exportComponent from "C:\\Users\\anton\\OneDrive\\Escritorios\\09-07-2023\\mailsender\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__